import { defineProvider } from '@nuxt/image/runtime'
import { joinURL } from 'ufo'

export default defineProvider({
  getImage(src, { modifiers }) {
    const url = joinURL(useRuntimeConfig().public.cdnBaseUrl, src);
    return { url };
  }
})